import { createColorClasses } from "@/theme/colors";
import { IconProps } from "@/types/icons.ts";
import clsx from "clsx";

export const ASL = ({
  width = 24,
  height = 24,
  className,
  color,
  decorative = false,
  ariaLabel = "ASL",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 24 24"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
        <path 
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#0066CC"
              d="M2 9L12 2L22 9H2ZM3 20V19H21V20H3ZM3 21V22H21V21H3ZM12 3.2L18.8 8H5.2L12 3.2ZM6 18V10H5V18H6ZM10 10V18H9V10H10ZM15 18V10H14V18H15ZM19 10V18H18V10H19Z"
        />
    </svg>
  );
};

